declare namespace $ {

	type $mol_text__text_shm_hitalama_extension_app_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $shm_hitalama_map_page__entity_shm_hitalama_extension_app_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_extension_app['map'] >
		,
		ReturnType< $shm_hitalama_map_page['entity'] >
	>
	type $shm_hitalama_map_page__tools_shm_hitalama_extension_app_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_page['tools'] >
	>
	export class $shm_hitalama_extension_app extends $shm_hitalama_app {
		extension_auto( ): readonly(any)[]
		map( ): $shm_hitalama_map
		extension_content( ): any
		auto( ): readonly(any)[]
		No_extension( ): $mol_text
		Map_page( ): $shm_hitalama_map_page
		Rpc( ): $mol_rpc_server
		Ext( ): any
	}
	
}

//# sourceMappingURL=app.web.view.tree.d.ts.map